<template>
  <div class="login-otp">
    <span>{{ $t('login_otp_translation') }}</span>
    <Button @click.native="handleClick" v-if="$t('login_as_client')" class="login-otp__btn">{{$t('login_as_client')}}</Button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Button from '../inputs/Button'
import axios from 'axios'
import qs from 'qs'

export default {
  name: 'LoginOtp',
  components: { Button },
  data () {
    return {
      urlParams: new URL(document.location).searchParams
    }
  },
  computed: mapGetters(['urlLanguagePrefix']),
  methods: {
    handleClick () {
      const params = {}
      const otp = this.urlParams.get('otp')
      const orderId = this.urlParams.get('order_id')

      if (otp) params.otp = otp
      if (orderId) params.order_id = orderId

      axios.post(this.urlLanguagePrefix + '/login-otp/', qs.stringify({ ...params }))
        .then(res => {
          if (res.data?.status === 'success') location.replace(res.data.redirect_to)
        })
    }
  }
}
</script>

<style scoped lang="sass">
.login-otp
  text-align: center

.login-otp__btn
  margin: 30px auto 0
</style>
